/** Avatar circular reutilizável: foto do cadastro ou iniciais quando não houver foto. */
export const initialsOf = (name) => {
  const parts = String(name || "")
    .split(" ")
    .filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const Avatar = ({ name, photoUrl, size = 36, testId, className = "" }) => {
  const src = photoUrl ? `${process.env.REACT_APP_BACKEND_URL}${photoUrl}` : null;
  return src ? (
    <img
      data-testid={testId}
      src={src}
      alt={`Foto de ${name || "funcionário"}`}
      style={{ width: size, height: size }}
      className={`shrink-0 rounded-full border border-border object-cover ${className}`}
    />
  ) : (
    <span
      data-testid={testId}
      aria-label={`Sem foto — ${name || "funcionário"}`}
      style={{ width: size, height: size, fontSize: Math.max(10, Math.round(size / 2.8)) }}
      className={`grid shrink-0 place-items-center rounded-full bg-sage-50 font-semibold text-sage-700 ${className}`}
    >
      {initialsOf(name)}
    </span>
  );
};
